module.exports = __webpack_public_path__ + "static/media/logo_mercadopago.e415b4a0.png";